export const translations = {
  en: {
    title: 'Privacy choices',
    description: 'We use cookies to improve your experience and measure site usage.',
    descriptionWithCompany: 'We use cookies to improve your experience with {companyName}.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject All',
    customize: 'Customize',
    reconsiderTitle: 'We respect your choice.',
    reconsiderDescription: 'Enable analytics for a better experience?',
    managePreferences: 'Manage Preferences',
    enableAnalytics: 'Enable Analytics',
    preferencesTitle: 'Privacy Preferences',
    preferencesDescription: 'Choose which cookies you allow',
    necessary: 'Necessary',
    analytics: 'Analytics',
    marketing: 'Marketing',
    savePreferences: 'Save Preferences',
    privacyButton: '🛡️ Privacy',
    privacyAriaLabel: 'Privacy',
    bannerAriaLabel: 'Cookie consent banner',
    closePreferences: 'Close preferences',
    necessaryDescription: 'Required for core site functionality. These cookies stay enabled.',
    analyticsDescription: 'Helps us understand usage and improve performance.',
    marketingDescription: 'Allows campaign measurement and personalized promotions.',
    returningTitle: "You're in control. Update your privacy settings anytime."
  },

  de: {
    title: 'Datenschutzeinstellungen',
    description: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und die Nutzung der Website zu analysieren.',
    descriptionWithCompany: 'Wir verwenden Cookies, um Ihre Erfahrung mit {companyName} zu verbessern.',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alle ablehnen',
    customize: 'Anpassen',
    reconsiderTitle: 'Wir respektieren Ihre Entscheidung.',
    reconsiderDescription: 'Möchten Sie Analytics aktivieren, um Ihre Erfahrung zu verbessern?',
    managePreferences: 'Einstellungen verwalten',
    enableAnalytics: 'Analytics aktivieren',
    preferencesTitle: 'Datenschutzeinstellungen',
    preferencesDescription: 'Wählen Sie aus, welche Cookies Sie zulassen möchten',
    necessary: 'Erforderlich',
    analytics: 'Analyse',
    marketing: 'Marketing',
    savePreferences: 'Einstellungen speichern',
    privacyButton: '🛡️ Datenschutz',
    privacyAriaLabel: 'Datenschutz',
    bannerAriaLabel: 'Cookie-Consent-Banner',
    closePreferences: 'Einstellungen schließen',
    necessaryDescription: 'Erforderlich für die grundlegende Funktionalität der Website. Diese Cookies bleiben aktiviert.',
    analyticsDescription: 'Hilft uns, die Nutzung zu verstehen und die Leistung zu verbessern.',
    marketingDescription: 'Ermöglicht Kampagnenmessung und personalisierte Angebote.',
    returningTitle: 'Sie haben die Kontrolle. Aktualisieren Sie Ihre Datenschutzeinstellungen jederzeit.'
  }
};
